import React from 'react';
import { Block } from 'slate';

import ImageInline from './imageInline.component';

export { default as InsertImageButton } from './insertImageButton.component';

export const IMAGE_BLOCK_TYPE = 'image';

const imagePlugin = () => ({
  renderInline: (props, editor, next) => {
    if (props.node.type === IMAGE_BLOCK_TYPE) {
      return <ImageInline {...props}/>;
    }
    return next();
  },
  schema: {
    document: {
      last: { type: 'paragraph' },
      normalize: (editor, { code, node }) => {
        switch (code) {
          case 'last_child_type_invalid': {
            const paragraph = Block.create('paragraph');
            return editor.insertNodeByKey(node.key, node.nodes.size, paragraph);
          }
          default:
            return;
        }
      },
    },
    inlines: {
      [IMAGE_BLOCK_TYPE]: {
        isVoid: true,
      },
    },
  },
  commands: {
    insertImage: (editor, src) => editor.insertInline({
      type: IMAGE_BLOCK_TYPE,
      isVoid: true,
      data: { src, align: null },
    }),
  },
  serialize: node => {
    if (node.type === IMAGE_BLOCK_TYPE && node.object === 'block') {
      const src = node.data.get('src');
      return <img src={src} style={{ display: 'block', maxWidth: '100vw', width: 'auto', height: 'auto' }} />;
    }
    if (node.type === IMAGE_BLOCK_TYPE && node.object === 'inline') {
      const src = node.data.get('src');
      const align = node.data.get('align');
      return <img src={src} style={{ float: align ? align : 'none', maxWidth: '100vw' }} />;
    }
  },
});

export default imagePlugin;
